module.exports = __webpack_public_path__ + "portal/assets/img/logo.4a915b8b.svg";